export default "__VITE_ASSET__Crv$osRj__"